import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Error", -1 /* HOISTED */)
const _hoisted_4 = { class: "font-size-xl mb-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" There was problem while loading the referral. Please try again. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" There was problem while generating the referral form. Please try again. ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl" }, "Loading Referral Form...", -1 /* HOISTED */)
const _hoisted_10 = {
  key: 2,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl text-center" }, "Saving Referral...", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "container-fluid my-2" }
const _hoisted_15 = { class: "d-flex justify-content-center mt-2 hh-button-container py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralDemographics = _resolveComponent("ReferralDemographics")!
  const _component_ReferralPayers = _resolveComponent("ReferralPayers")!
  const _component_ReferralPhysicians = _resolveComponent("ReferralPhysicians")!
  const _component_ClinicalDiagnosis = _resolveComponent("ClinicalDiagnosis")!
  const _component_ReferralPharmacy = _resolveComponent("ReferralPharmacy")!
  const _component_ReferralContacts = _resolveComponent("ReferralContacts")!
  const _component_EmergencyPreparedness = _resolveComponent("EmergencyPreparedness")!
  const _component_AdvanceDirectives = _resolveComponent("AdvanceDirectives")!
  const _component_ReferralInformation = _resolveComponent("ReferralInformation")!
  const _component_TabsLayout = _resolveComponent("TabsLayout")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createBlock(_component_PageLayout, {
    "has-buttons": false,
    "has-title": false,
    id: "Home_Health_Edit_Patient",
    "content-class": "p-0"
  }, {
    content: _withCtx(() => [
      (_ctx.isLoadError || _ctx.isFormLoading || _ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.isLoadError && !_ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, [
                    (_ctx.referralId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_5
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_6
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  _hoisted_7,
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadReferral()))
                  }, "Try Again")
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.isFormLoading && !_ctx.isLoadError)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_8,
                  _hoisted_9
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
        ? (_openBlock(), _createBlock(_component_TabsLayout, {
            key: 1,
            header: `Edit Home Health Referral-${_ctx.formatName(
                        _ctx.referral.Demographics.FirstName,
                        _ctx.referral.Demographics.LastName
                    )}`,
            tabs: _ctx.tabs,
            activeTab: _ctx.activeTab,
            handleTabChange: _ctx.handleTabChange,
            showErrors: (tab) => _ctx.getNumberOfErrors(tab.name) > 0,
            numberOfErrors: (tab) => _ctx.getNumberOfErrors(tab.name),
            showWarnings: 
                        (tab) =>
                            (_ctx.getNumberOfWarnings(tab.name) > 0 && _ctx.allErrors.includes(tab.id)) ||
                            (_ctx.getNumberOfWarnings(tab.name) > 0 && _ctx.previousTabs.includes(tab.id))
                    ,
            showSuccess: 
                        (tab) =>
                            (_ctx.getNumberOfWarnings(tab.name) === 0 &&
                                _ctx.getNumberOfErrors(tab.name) === 0 &&
                                _ctx.allErrors.includes(tab.id)) ||
                            (_ctx.getNumberOfWarnings(tab.name) === 0 &&
                                _ctx.getNumberOfErrors(tab.name) === 0 &&
                                _ctx.previousTabs.includes(tab.id))
                    ,
            numberOfWarnings: (tab) => _ctx.getNumberOfWarnings(tab.name)
          }, _createSlots({
            forms: _withCtx(() => [
              _createElementVNode("section", _hoisted_14, [
                _withDirectives(_createVNode(_component_ReferralDemographics, {
                  "branch-id": _ctx.branchId,
                  "is-editing": !_ctx.isCreate,
                  onChangeBranchId: _ctx.changeBranchId,
                  onIsSSNDuplicate: _ctx.isSSNDuplicate
                }, null, 8 /* PROPS */, ["branch-id", "is-editing", "onChangeBranchId", "onIsSSNDuplicate"]), [
                  [_vShow, _ctx.activeTab === 1]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_ReferralPayers)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 2]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_ReferralPhysicians)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 3]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_ClinicalDiagnosis)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 4]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_ReferralPharmacy)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 5]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_ReferralContacts)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 6]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_EmergencyPreparedness)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 7]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_AdvanceDirectives)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 8]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_ReferralInformation)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.activeTab === 9]
                ])
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, [
            (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
              ? {
                  name: "buttons",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary me-2",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlePatientConversion('reAdmit')))
                        }, " Admit ")
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary me-2",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlePatientConversion('covtToPending')))
                        }, " Convert to Pending ")
                      ]),
                      (_ctx.activeTab !== 9)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary me-2",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.update('save-and-continue')))
                          }, " Save and Continue "))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary me-2",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.update('save-and-exit')))
                      }, " Save and Exit "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleCancel()))
                      }, " Cancel ")
                    ])
                  ])
                }
              : undefined
          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["header", "tabs", "activeTab", "handleTabChange", "showErrors", "numberOfErrors", "showWarnings", "showSuccess", "numberOfWarnings"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}